<template>
  <div
    :id="postHash"
    class="founder-outer-container"
  >
    <div class="container">
      <div class="founder-inner-container">
        <h3 class="pdp-section-header font-weight-bold mb-4">
          From the founders
        </h3>

        <div class="row">
          <div class="col-lg-4">
            <ProductsFoundersProfile
              :product-url="productUrl"
              :is-select="isSelect"
              :user="postUser"
            />

            <ProductsFoundersCard
              class="d-none d-lg-block"
              :posts="posts"
              :links="links"
              :post-index="postIndex"
              :highlight-selected-post="true"
              @click-post="clickPost"
            />
          </div>

          <div class="col-lg-8">
            <div
              v-for="(post, index) in posts"
              :key="`post${index}`"
              :data-post-id="`founder-post-${index + 1}`"
            >
              <div
                v-show="postIndex === index"
                class="pt-3 pt-lg-0 founders-content"
                :class="{ 'active': postIndex === index && !transitioningBetweenPosts }"
              >
                <h6 class="font-weight-medium text-muted">
                  {{ post.title }}
                </h6>
                <ProductsFoundersBody :text="post.message" />
              </div>
            </div>
          </div>

          <ProductsFoundersCard
            class="col d-lg-none"
            :posts="posts"
            :links="links"
            :post-index="postIndex"
            :highlight-selected-post="true"
            @click-post="clickPost"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PDPScrollToElementMixin from '../../pdp/mixins/PDPScrollToElementMixin';
import ProductsFoundersProfile from './ProductsFoundersProfile';
import ProductsFoundersCard from './ProductsFoundersCard';
import ProductsFoundersBody from './ProductsFoundersBody';

export default {
  components: {
    ProductsFoundersProfile,
    ProductsFoundersCard,
    ProductsFoundersBody,
  },
  mixins: [PDPScrollToElementMixin],
  props: {
    productUrl: {
      type: Object,
      default: null,
    },
    isSelect: {
      type: Boolean,
    },
    posts: {
      type: Array,
      required: true,
    },
    links: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      postIndex: 0,
      transitioningBetweenPosts: false,
    };
  },
  computed: {
    postUser() {
      return this.posts[this.postIndex].user;
    },
    postHash() {
      return `founder-post-${this.postIndex + 1}`;
    },
  },
  created() {
    const { hash } = this.$route;

    // an: expected format hash: 'founder-post-{number}'
    if (hash?.includes('founder-post-')) {
      const postNumber = Number(hash.charAt(hash.length - 1)) || 1;

      if (postNumber >= 1 && postNumber <= this.posts.length) {
        // an: Set index from hash Post number as index zero-based
        this.postIndex = postNumber - 1;
      }
    }
  },
  methods: {
    clickPost(index) {
      this.postIndex = index;
      this.transitioningBetweenPosts = true;

      // jw: we need to handle this navigation change in the next tick, which should allow the
      //     links card to be repositioned for mobile which will allow distance for scrolling calcs
      //     to be accurate. Technically only needed when scrolling down on mobile, but always doing
      //     this keeps the code cleaner.
      this.$nextTick(() => {
        // jw: push the hash into the history so that reverse navigation can be handled in
        //     PDPSectionTabs.
        window.history.pushState({}, '', `#${this.postHash}`);
        this.$_scrollToElement(document.querySelector(`#${this.postHash}`));

        // an: Once render is done we complete the transition to add an 'active` class
        //     in order to display the post with smoother transition using CSS animation
        this.transitioningBetweenPosts = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~/styles/dorado/main'; // TODO -- Remove once auto imported
  .founder-outer-container {
    background-color: $gray-100;
    padding: 47px 0;
  }

  .founder-inner-container {
    .founders-content {
      opacity: 0;
      transition: opacity 0.5s ease-in;

      &.active {
        opacity: 1;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .founder-outer-container {
      padding: 24px 0;
    }

    .founder-inner-container {
      h3 {
        font-size: 1.5rem;
      }
    }
  }
</style>
